module.exports = __webpack_public_path__ + "img/tags.23d2502e.svg";